module.exports = __webpack_public_path__ + "static/media/vendor_neutral.ef6ca5c3.svg";